import React from 'react'
import { Container } from 'reactstrap'
import { Link } from 'react-router-dom'

import { Alert } from '../../../components/reactstrap'
import PropTypes from 'prop-types'
import { Trans, useTranslation } from 'react-i18next'

const ImportIssuesBanner = ({ count, projectId }) => {
  const { t } = useTranslation('ProjectsPage')

  return (
    <Container fluid>
      <Alert className="d-flex flex-row flex-fill justify-content-between align-items-center" color="warning">
        <div className="d-block">
          <Trans i18nKey="ProjectsPage:ImportIssues.alert.message" count={count}>
            This project has&nbsp;
            <strong>
              {{ count }}
              &nbsp;conflicts and/or missing locales
            </strong>
            , please fix impacted strings.
          </Trans>
        </div>
        <Link
          className="btn btn-outline-warning text-warning text-decoration-none px-5"
          to={`/projects/${projectId}/issues`}
        >
          {t('ImportIssues.alert.button')}
        </Link>
      </Alert>
    </Container>
  )
}

ImportIssuesBanner.propTypes = {
  count: PropTypes.number.isRequired,
  projectId: PropTypes.string.isRequired
}

export default ImportIssuesBanner
